import { FC } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import { ArrowUpRightIcon } from 'lucide-react'
import { Logo } from '../../assets'
import { setShowAuthModal, setShowUserMenu, useAppDispatch, useAppSelector } from '../../redux'
import { HEADER_LINKS, ROUTES, useIsMobile, useUser } from '../../utils'
import { Avatar, UserMenu } from '..'
import { StyledHeader } from '.'

const Header: FC = () => {
  const dispatch = useAppDispatch()
  const { isMobile } = useIsMobile()
  const { pathname } = useLocation()
  const { user } = useAppSelector((state) => state.user)
  const { showUserMenu } = useAppSelector((state) => state.state)

  if (isMobile && window.self !== window.top) {
    return null
  }

  return (
    <StyledHeader $blend={!!pathname.includes('/preview')}>
      <Link to={ROUTES.home} className="logo">
        <Logo />
      </Link>
      {window.self === window.top && (
        <nav>
          {HEADER_LINKS.map((link) => {
            if (link.external) {
              return (
                <a href={link.href} target="_blank" key={link.label}>
                  {link.label} <ArrowUpRightIcon />
                </a>
              )
            }

            return (
              <NavLink to={link.href} exact={link.exact} key={link.label}>
                {link.label}
              </NavLink>
            )
          })}
        </nav>
      )}
      <div className="header-actions">
        {!user && (
          <>
            <a href={ROUTES.external.auth} target="_self" className="login-btn header-btn">
              Log In
            </a>
            {/* <button
              className="signup-btn header-btn"
              onClick={() => dispatch(setShowAuthModal(true))}
            >
              Sign Up & Learn
            </button> */}
          </>
        )}
        {!!user && <Avatar onClick={() => dispatch(setShowUserMenu(true))} />}
      </div>
      {showUserMenu && <UserMenu />}
    </StyledHeader>
  )
}

export default Header
